import { ForexDraftMutation } from "@/feature/Forex/store/draft/constants";
import ObjectUtils from "@/modules/Object/ObjectUtils";
import { ForexDraftFilter } from "@/feature/Forex/api/draft/forex-draft.interface";
import { ForexDraftState } from "@/feature/Forex/store/draft/interface";
import { Commit } from "vuex";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";

export const getDraftFilter = (
	state: ForexDraftState
): ForexDraftFilter => {
	const filter = ObjectUtils.excludeEmpty({
		type: state.operationType === ForexOperationType.ALL
			? undefined
			: state.operationType,
		dateFrom: state.dateFrom,
		dateTo: state.dateTo,
		currency: state.currency,
		pageNumber: state.pageNumber,
		elementsOnPage: state.pageSize
	});

	if ((filter.dateFrom && !filter.dateTo)
		|| (!filter.dateFrom && filter.dateTo)) {
		delete filter.dateFrom;
		delete filter.dateTo;
	}

	return filter;
};

export const getDraftNextPageFilters = (
	state: ForexDraftState,
	commit: Commit
): ForexDraftFilter => {
	if (!state.isEndPage)
		commit(ForexDraftMutation.setNextPage);

	return getDraftFilter(state);
};